var _excluded = ["extent"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isString } from 'vega-util';
import { binToString, isBinning, isParameterExtent } from '../../bin';
import { binRequiresRange, isTypedFieldDef, normalizeBin, vgField } from '../../channeldef';
import { duplicate, hash as _hash, isEmpty, keys, replacePathInField, unique, vals } from '../../util';
import { binFormatExpression } from '../format';
import { isUnitModel } from '../model';
import { parseSelectionExtent } from '../selection/parse';
import { DataFlowNode } from './dataflow';
function rangeFormula(model, fieldDef, channel, config) {
  if (binRequiresRange(fieldDef, channel)) {
    var _ref, _model$axis;
    // read format from axis or legend, if there is no format then use config.numberFormat
    var guide = isUnitModel(model) ? (_ref = (_model$axis = model.axis(channel)) !== null && _model$axis !== void 0 ? _model$axis : model.legend(channel)) !== null && _ref !== void 0 ? _ref : {} : {};
    var startField = vgField(fieldDef, {
      expr: 'datum'
    });
    var endField = vgField(fieldDef, {
      expr: 'datum',
      binSuffix: 'end'
    });
    return {
      formulaAs: vgField(fieldDef, {
        binSuffix: 'range',
        forAs: true
      }),
      formula: binFormatExpression(startField, endField, guide.format, guide.formatType, config)
    };
  }
  return {};
}
function binKey(bin, field) {
  return "".concat(binToString(bin), "_").concat(field);
}
function getSignalsFromModel(model, key) {
  return {
    signal: model.getName("".concat(key, "_bins")),
    extentSignal: model.getName("".concat(key, "_extent"))
  };
}
export function getBinSignalName(model, field, bin) {
  var _normalizeBin;
  var normalizedBin = (_normalizeBin = normalizeBin(bin, undefined)) !== null && _normalizeBin !== void 0 ? _normalizeBin : {};
  var key = binKey(normalizedBin, field);
  return model.getName("".concat(key, "_bins"));
}
function isBinTransform(t) {
  return 'as' in t;
}
function createBinComponent(t, bin, model) {
  var as;
  var span;
  if (isBinTransform(t)) {
    as = isString(t.as) ? [t.as, "".concat(t.as, "_end")] : [t.as[0], t.as[1]];
  } else {
    as = [vgField(t, {
      forAs: true
    }), vgField(t, {
      binSuffix: 'end',
      forAs: true
    })];
  }
  var normalizedBin = _objectSpread({}, normalizeBin(bin, undefined));
  var key = binKey(normalizedBin, t.field);
  var _getSignalsFromModel = getSignalsFromModel(model, key),
    signal = _getSignalsFromModel.signal,
    extentSignal = _getSignalsFromModel.extentSignal;
  if (isParameterExtent(normalizedBin.extent)) {
    var ext = normalizedBin.extent;
    span = parseSelectionExtent(model, ext.param, ext);
    delete normalizedBin.extent; // Vega-Lite selection extent map to Vega's span property.
  }
  var binComponent = _objectSpread(_objectSpread(_objectSpread({
    bin: normalizedBin,
    field: t.field,
    as: [as]
  }, signal ? {
    signal: signal
  } : {}), extentSignal ? {
    extentSignal: extentSignal
  } : {}), span ? {
    span: span
  } : {});
  return {
    key: key,
    binComponent: binComponent
  };
}
export var BinNode = /*#__PURE__*/function (_DataFlowNode) {
  function BinNode(parent, bins) {
    var _this;
    _classCallCheck(this, BinNode);
    _this = _callSuper(this, BinNode, [parent]);
    _this.bins = bins;
    return _this;
  }
  _inherits(BinNode, _DataFlowNode);
  return _createClass(BinNode, [{
    key: "clone",
    value: function clone() {
      return new BinNode(null, duplicate(this.bins));
    }
  }, {
    key: "merge",
    value:
    /**
     * Merge bin nodes. This method either integrates the bin config from the other node
     * or if this node already has a bin config, renames the corresponding signal in the model.
     */
    function merge(other, renameSignal) {
      var _iterator = _createForOfIteratorHelper(keys(other.bins)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          if (key in this.bins) {
            renameSignal(other.bins[key].signal, this.bins[key].signal);
            // Ensure that we don't have duplicate names for signal pairs
            this.bins[key].as = unique([].concat(_toConsumableArray(this.bins[key].as), _toConsumableArray(other.bins[key].as)), _hash);
          } else {
            this.bins[key] = other.bins[key];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(other.children),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          other.removeChild(child);
          child.parent = this;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      other.remove();
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(vals(this.bins).map(function (c) {
        return c.as;
      }).flat(2));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(vals(this.bins).map(function (c) {
        return c.field;
      }));
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Bin ".concat(_hash(this.bins));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return vals(this.bins).flatMap(function (bin) {
        var transform = [];
        var _bin$as = _toArray(bin.as),
          binAs = _bin$as[0],
          remainingAs = _bin$as.slice(1);
        var _bin$bin = bin.bin,
          extent = _bin$bin.extent,
          params = _objectWithoutProperties(_bin$bin, _excluded);
        var binTrans = _objectSpread(_objectSpread(_objectSpread({
          type: 'bin',
          field: replacePathInField(bin.field),
          as: binAs,
          signal: bin.signal
        }, !isParameterExtent(extent) ? {
          extent: extent
        } : {
          extent: null
        }), bin.span ? {
          span: {
            signal: "span(".concat(bin.span, ")")
          }
        } : {}), params);
        if (!extent && bin.extentSignal) {
          transform.push({
            type: 'extent',
            field: replacePathInField(bin.field),
            signal: bin.extentSignal
          });
          binTrans.extent = {
            signal: bin.extentSignal
          };
        }
        transform.push(binTrans);
        var _iterator3 = _createForOfIteratorHelper(remainingAs),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var as = _step3.value;
            for (var i = 0; i < 2; i++) {
              transform.push({
                type: 'formula',
                expr: vgField({
                  field: binAs[i]
                }, {
                  expr: 'datum'
                }),
                as: as[i]
              });
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        if (bin.formula) {
          transform.push({
            type: 'formula',
            expr: bin.formula,
            as: bin.formulaAs
          });
        }
        return transform;
      });
    }
  }], [{
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var bins = model.reduceFieldDef(function (binComponentIndex, fieldDef, channel) {
        if (isTypedFieldDef(fieldDef) && isBinning(fieldDef.bin)) {
          var _createBinComponent = createBinComponent(fieldDef, fieldDef.bin, model),
            key = _createBinComponent.key,
            binComponent = _createBinComponent.binComponent;
          binComponentIndex[key] = _objectSpread(_objectSpread(_objectSpread({}, binComponent), binComponentIndex[key]), rangeFormula(model, fieldDef, channel, model.config));
        }
        return binComponentIndex;
      }, {});
      if (isEmpty(bins)) {
        return null;
      }
      return new BinNode(parent, bins);
    }
    /**
     * Creates a bin node from BinTransform.
     * The optional parameter should provide
     */
  }, {
    key: "makeFromTransform",
    value: function makeFromTransform(parent, t, model) {
      var _createBinComponent2 = createBinComponent(t, t.bin, model),
        key = _createBinComponent2.key,
        binComponent = _createBinComponent2.binComponent;
      return new BinNode(parent, _defineProperty({}, key, binComponent));
    }
  }]);
}(DataFlowNode);